<template>
  <div>
    <!--just emits that the form is valid, the parent should handle whats next-->
    <mobialis-form-with-validation
      @onValidate="emitValidation"
      v-av-analytics-form-submit="{ elementText: $t(`message.${this.buttonLabelKey}`) }"
    >
      <div :class="{ 'row justify-content-between': sampleReport }">
        <div :class="{ 'col-sm-7': sampleReport }">
          <mobialis-text-input-with-validation
            :rules="{ required: true, regex: /^([^0-9]*)$/ }"
            :label="$t('message.common.firstName')"
            v-model="firstName"
            vid="firstName"
            data-cy="firstName"
          >
          </mobialis-text-input-with-validation>
          <mobialis-text-input-with-validation
            :rules="{ required: true, regex: /^([^0-9]*)$/ }"
            :label="$t('message.common.lastName')"
            v-model="lastName"
            vid="lastName"
            data-cy="lastName"
          >
          </mobialis-text-input-with-validation>

          <mobialis-text-input-with-validation
            rules="required|length:10"
            :label="$t('message.common.mobileNumber')"
            v-model="phoneNumber"
            vid="phoneNumber"
            placeholder="(   )"
            mask-type="phoneNumber"
            type="tel"
            data-cy="phoneNumber"
            :error-message="avErrors['phoneNumber']"
          >
          </mobialis-text-input-with-validation>
          <mobialis-text-input-with-validation
            v-if="!getThisIsAmerica && postalCodeRequired"
            :rules="postalCodeRequirement"
            :label="$t('message.common.postalCode')"
            :helper="$t(postalCodeHint)"
            v-model="postalCode"
            vid="postalCode"
            mask-type="postalCode"
            data-cy="postalCode"
          >
          </mobialis-text-input-with-validation>

          <mobialis-text-input-with-validation
            rules="required|email"
            :label="$t('message.common.emailAddress')"
            :helper="$t('message.trade.infoForm.emailHelper')"
            v-model="emailAddress"
            vid="emailAddress"
            class="mt-0"
            data-cy="emailAddress"
            type="email"
            :error-message="avErrors['emailAddress']"
          >
          </mobialis-text-input-with-validation>
          <mobialis-text-input-with-validation
            v-if="!hideMileage"
            rules="required"
            :label="$t('message.trade.infoForm.mileage')"
            :helper="$t('message.trade.infoForm.mileageHelper')"
            v-model="mileage"
            vid="mileage"
            inputmode="numeric"
            :mask-type="languageCode === 'fr-CA' ? 'frenchInt' : 'int'"
            data-cy="mileage"
          >
          </mobialis-text-input-with-validation>
          <!-- OPTIONAL: Vehicle of Interest -->
          <mobialis-selection-input-with-validation
            v-if="showingVehicleOfInterest"
            rules=""
            :label="$t('message.trade.infoForm.oemOfInterest')"
            v-model="oemOfInterest"
            vid="oemOfInterest"
            :options="vehicleMakes"
            data-cy="oemOfInterest"
          ></mobialis-selection-input-with-validation>
          <mobialis-check-box-with-validation
            rules="required:true"
            :label="TermsText"
            vid="tandc"
            id="tandc"
            data-cy="tAndC"
          >
          </mobialis-check-box-with-validation>
        </div>
        <div v-if="sampleReport" class="col-sm-5 d-none d-sm-block">
          <div class="text-center pl-4">
            <img
              :src="require(`@/assets/sample-report-${$i18n.locale}.png`)"
              class="sample-report-image"
              alt="Sample Report"
            />
            <small>{{ $t('message.trade.sampleReport') }}</small>
          </div>
        </div>
      </div>
      <mobialis-button type="submit" class="mt-4" data-cy="submit">{{
        $t(`message.${this.buttonLabelKey}`)
      }}</mobialis-button>
      <p class="text-center p-small">{{ footNoteText }}</p>
    </mobialis-form-with-validation>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { AVRProducts } from '@/utils/enums';
import makes from '../../utils/vehiclesOfInterest';

export default {
  name: 'PersonalInfoForm',
  data() {
    return {
      vehicleMakes: makes,
    };
  },
  props: {
    sampleReport: {
      type: Boolean,
      default: false,
    },
    buttonLabelKey: {
      type: String,
      default: 'next',
    },
    footNoteKey: {
      type: String,
    },
    avErrors: {
      type: Object,
    },
    hideMileage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('business', [
      'getTradeInSource',
      'getThisIsAmerica',
      'getFeatureList',
      'getBusinessName',
      'isKijijiDealer',
      'tradeAcquireAdditionalVehicleDetails',
    ]),
    ...mapGetters(['getCurrentProduct']),
    ...mapGetters({
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
    }),
    TermsText() {
      if (this.isKijijiDealer) {
        return this.$t('message.trade.infoForm.checkBoxLabelKijiji', {
          link: this.TermsLink,
          dealer: this.getBusinessName,
        });
      }
      if (this.getCurrentProduct === AVRProducts.ACQUIRE) {
        return this.$t('message.acquire.infoForm.checkBoxLabel', {
          link: this.TermsLink,
          dealer: this.getBusinessName,
        });
      }
      return this.$t('message.trade.infoForm.checkBoxLabel', { link: this.TermsLink, dealer: this.getBusinessName });
    },
    TermsLink() {
      return this.$t('message.trade.infoForm.checkBoxLink');
    },
    showingVehicleOfInterest() {
      return this.getFeatureList.tradeVehicleOfInterest;
    },
    footNoteText() {
      if (this.footNoteKey && this.footNoteKey !== '') {
        return this.$t(this.footNoteKey);
      }

      if (this.tradeAcquireAdditionalVehicleDetails) {
        return '';
      }

      return this.isAVRAcquire ? this.$t('message.acquire.buttonInfo') : this.$t('message.trade.buttonInfo');
    },
    firstName: {
      get() {
        return this.$store.state.user.firstName;
      },
      set(value) {
        this.$store.commit('user/SET_FIRST_NAME', value); // maybe add { root: true }
      },
    },
    lastName: {
      get() {
        return this.$store.state.user.lastName;
      },
      set(value) {
        this.$store.commit('user/SET_LAST_NAME', value); // maybe add { root: true }
      },
    },
    emailAddress: {
      get() {
        return this.$store.state.user.emailAddress;
      },
      set(value) {
        this.$store.commit('user/SET_EMAIL_ADDRESS', value); // maybe add { root: true }
      },
    },
    phoneNumber: {
      get() {
        return this.$store.state.user.phoneNumber;
      },
      set(value) {
        this.$store.commit('user/SET_PHONE_NUMBER', value); // maybe add { root: true }
      },
    },
    postalCode: {
      get() {
        return this.$store.state.user.postalCode;
      },
      set(value) {
        this.$store.commit('user/SET_POSTAL_CODE', value);
      },
    },
    postalCodeRequired() {
      if (this.getCurrentProduct === AVRProducts.ACQUIRE) {
        return this.getFeatureList.acquirePostalCodeRequired;
      }
      return this.getFeatureList.tradePostalCodeRequired;
    },
    postalCodeRequirement() {
      if (this.getCurrentProduct === AVRProducts.ACQUIRE) {
        return this.getFeatureList.acquirePostalCodeRequired ? 'required|length:6' : 'length:6';
      }
      return this.getFeatureList.tradePostalCodeRequired ? 'required|length:6' : 'length:6';
    },
    postalCodeHint() {
      if (this.getCurrentProduct === AVRProducts.ACQUIRE) {
        return 'message.common.acquirePostalHint';
      }
      return 'message.common.postalHint';
    },
    mileage: {
      get() {
        return this.$store.state.trade.vehicle.mileage;
      },
      set(value) {
        this.$store.commit('trade/SET_VEHICLE_MILEAGE', value); // maybe add { root: true }
      },
    },
    oemOfInterest: {
      get() {
        return this.$store.state.user.oemOfInterest;
      },
      set(value) {
        this.$store.commit('user/SET_OEM_OF_INTEREST', value);
      },
    },
    isAVRAcquire() {
      return this.getCurrentProduct === AVRProducts.ACQUIRE;
    },
  },
  methods: {
    emitValidation(isValid) {
      this.$emit('FormIsValid', isValid);
    },
  },
};
</script>

<style scoped lang="scss">
.form-check::v-deep {
  margin-top: 5px;
  label.form-check-label {
    p {
      margin-top: 0;
      margin-bottom: 7px;
    }
    ul,
    ol {
      padding-left: 25px;
    }
    p,
    ul,
    li,
    ol {
      color: #4b5863;
      font-size: 12px;
      line-height: 18px;
    }
  }
}
.sample-report-image {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}
</style>
